/* eslint-disable react/no-array-index-key */
import { Box, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

const chunkIntoRows = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

function WhiteListedPhoneNumber({ csvValue }) {
  try {
    if (csvValue.includes(',')) {
      const numbers = csvValue.split(',');
      const rows = chunkIntoRows(numbers, 3);
      return (
        <Box>
          {rows.map((row, rowIndex) => (
            <Grid2 container key={rowIndex} sx={{ mb: 0.2 }}>
              {row.map((number, colIndex) => (
                <Grid2 xs={4} key={colIndex}>
                  <Typography variant="body2">{number}</Typography>
                </Grid2>
              ))}
            </Grid2>
          ))}
        </Box>
      );
    }
  } catch {
    return csvValue;
  }
  return csvValue;
}

function safeDate(value) {
  if (value == null || value === '') return null;
  return dayjs(value).format(DATE_FORMAT.LONG_DATE);
}

function configName(row) {
  if (!row) return '-';
  const name = row.name ?? '-';
  if (!row.id) return name;
  return <Link to={`/insight-config/edit/${row.id}`}>{name}</Link>;
}

function configValue(row) {
  if (row.name === 'WHITELISTED_PHONE_NUMBER') {
    return row?.value ? <WhiteListedPhoneNumber csvValue={row?.value} /> : '-';
  }
  return row?.value ?? '-';
}

function configDescription(row) {
  return row?.description ?? '-';
}

function createdDateTime(row) {
  return safeDate(row?.createdDateTime);
}

function lastModifiedDateTime(row) {
  return safeDate(row?.lastModifiedDateTime);
}

export {
  configName,
  configValue,
  configDescription,
  createdDateTime,
  lastModifiedDateTime,
};
